// extracted by css-extract-rspack-plugin
export default {"root":"MX7rn","content":"IS4DN","outline":"wjWPb"};